const options = {
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  timeZoneName: "short",
};

export const formatDate = (date: any) => {
  return formatDateWithOptions(date, options);
};

export const formatDateWithOptions = (date: any, formatOptions: any) => {
  // @ts-ignore
  return new Intl.DateTimeFormat("en-US", formatOptions).format(date);
};
